import { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { CommonUIError } from '@afterpay/types'
import { isCallable } from '@afterpay/utils'

import { isValidObject } from '../utils/object'
export interface UseVisibleHook {
  isVisible: boolean
  values: any
}

export interface UseVisibleConfig {
  name: string
  show: boolean | ((values?: any) => boolean)
}

export interface UseErrorHook extends CommonUIError {
  isError: boolean
}

export interface UseErrorConfig extends CommonUIError {
  name: string
}

export const useVisible = ({ name, show }: UseVisibleConfig): UseVisibleHook => {
  const { watch } = useFormContext()
  const values = watch(name)
  const isVisible: boolean = useMemo(() => (isCallable(show) ? show(values) : show), [values, show])

  return { isVisible, values }
}

export const useError = ({ name, error = false, errorText: errorMessage }: UseErrorConfig): UseErrorHook => {
  const {
    formState: { errors },
  } = useFormContext()
  const isError = error || isValidObject(errors[name])
  const errorText = errorMessage ?? (errors[name]?.message as string | undefined) ?? ''

  return { isError, errorText }
}
